export enum PaymentStatus {
  Pending = 'pending',
  Authorized = 'authorized',
  Ordered = 'ordered',
  Paid = 'paid',
  Expired = 'expired',
  Canceled = 'canceled',
  Suspended = 'suspended'
}

export class PaymentStatusHelper {
  static GetCyrilicName(value: string | undefined | null): string {
    if (!value) return 'Няма';

    switch (value.toLowerCase()) {
      case PaymentStatus.Pending:
        return 'Изчакване';
      case PaymentStatus.Authorized:
        return 'Оторизирано';
      case PaymentStatus.Ordered:
        return 'Поръчано';
      case PaymentStatus.Paid:
        return 'Платено';
      case PaymentStatus.Expired:
        return 'Изтекло';
      case PaymentStatus.Canceled:
        return 'Отказано';
      case PaymentStatus.Suspended:
        return 'Спряно';
      default:
        return 'Няма';
    }
  }

  static GetBadgeClass(value: string | undefined | null): string {
    if (!value) return 'badge bg-secondary';

    switch (value.toLowerCase()) {
      case PaymentStatus.Paid:
        return 'badge bg-success';
      case PaymentStatus.Pending:
      case PaymentStatus.Authorized:
      case PaymentStatus.Ordered:
        return 'badge bg-info';
      case PaymentStatus.Expired:
      case PaymentStatus.Canceled:
      case PaymentStatus.Suspended:
        return 'badge bg-danger';
      default:
        return 'badge bg-secondary';
    }
  }
}
